import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private titleSubject = new BehaviorSubject<string>('Cervino');
  private iconSubject = new BehaviorSubject<string>('pi pi-home');
  public title$: Observable<string> = this.titleSubject.asObservable();
  public icon$: Observable<string> = this.iconSubject.asObservable();

  setTitle(newTitle: string): void {
    this.titleSubject.next(newTitle);
  }

  setIcon(newIcon: string): void {
    this.iconSubject.next(newIcon);
  }

  getCurrentTitle(): string {
    return this.titleSubject.getValue();
  }

  getCurrentIcon(): string {
    return this.iconSubject.getValue();
  }
}
